import { render, staticRenderFns } from "./techerDisplayWidge.vue?vue&type=template&id=c432c5c4&scoped=true"
import script from "./techerDisplayWidge.vue?vue&type=script&lang=js"
export * from "./techerDisplayWidge.vue?vue&type=script&lang=js"
import style0 from "./techerDisplayWidge.vue?vue&type=style&index=0&id=c432c5c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c432c5c4",
  null
  
)

export default component.exports